import * as React from 'react';

// You can likely remove this import if you aren't using other styles from it
import '../../assets/styles/LoginCallback.css';

interface Props {
}
interface State {
    userMessage: string;
}

class Logout extends React.PureComponent<Props, State> {

    public state = {
        userMessage: 'please wait...',
    };
    
    public async componentDidMount() {
        // Optional: Small delay to let the user see the "logging out" screen
        await new Promise(r => setTimeout(r, 500));
        
        localStorage.setItem('token', '');
        localStorage.setItem('userInfo', ''); 
        
        this.setState({userMessage: 'redirecting...'});
        
        await new Promise(r => setTimeout(r, 500));
        window.location = "/" as (string | Location) & Location;        
    }

    public render() {
        return (
            <div style={styles.container}>
                <div style={styles.content}>
                    {/* You could add a spinner icon here if you have one, e.g. <Spinner /> */}
                    <h2 style={styles.heading}>Logging out...</h2>
                    <p style={styles.subtext}>{this.state.userMessage}</p>
                </div>
            </div>
        );
    }
}

// Simple inline styles for centering
const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: '#f8f9fa', // Optional: light gray background so it's not stark white
    } as React.CSSProperties,
    content: {
        textAlign: 'center' as 'center',
    } as React.CSSProperties,
    heading: {
        marginBottom: '10px',
        color: '#333',
    } as React.CSSProperties,
    subtext: {
        color: '#666',
        fontSize: '1.1em',
    } as React.CSSProperties
};

export default Logout;